import React from 'react';
import OrderDesign from '../../../OrderDesign';
import { SPOTTING_OBJECTS_BACKGROUND_SRC } from './spottingObjectsLayout';

/**
 * Background + center order lens (duplicated for base and magnifier layers).
 */
export default function SpottingObjectsSceneContent({ order, orderLoading, lensOrderScale }) {
  return (
    <>
      <img
        src={SPOTTING_OBJECTS_BACKGROUND_SRC}
        alt=""
        className="spotting-objects-bg"
        draggable={false}
        onDragStart={(e) => e.preventDefault()}
      />
      <div className="spotting-objects-lens" aria-hidden="true">
        <div className="spotting-objects-order-scale" style={{ transform: `scale(${lensOrderScale})` }}>
          {order ? (
            <OrderDesign order={order} count={0} minimal showButtons={false} />
          ) : orderLoading ? (
            <div className="spotting-objects-order-loading" />
          ) : null}
        </div>
      </div>
    </>
  );
}
